import { getFounders } from '../data'
import { getDepartments } from '../data/departments'
import DrawnApostrophe from './DrawnApostrophe'
import { L, useLocale, useT } from '../i18n/locale.jsx'
import { BOOKING_URL } from '../config'
import { calAttrs } from '../cal'

// Footer forest-deep cu wordmark 'vorba uriaș + CTA. Linkuri reale (rute + LinkedIn).
export default function Footer() {
  const locale = useLocale()
  const t = useT().footer
  const departments = getDepartments(locale)
  const founders = getFounders(locale)
  return (
    <footer data-theme="dark" className="overflow-hidden bg-forest-deep px-5 pb-8 pt-20 text-cream md:px-10">
      <div className="mx-auto max-w-site">
        <div className="flex flex-wrap items-center justify-between gap-6 border-b border-forest-line pb-8">
          <nav className="flex flex-wrap gap-x-5 gap-y-1">
            {departments.map((d) => (
              <L key={d.slug} to={`/${d.slug}`} className="eyebrow-light inline-flex min-h-[44px] items-center">{d.label}</L>
            ))}
            {founders.map((f) => (
              <a key={f.name} href={f.linkedin} target="_blank" rel="noopener noreferrer" className="eyebrow-light inline-flex min-h-[44px] items-center">
                {f.name.split(' ')[0]} ↗
              </a>
            ))}
          </nav>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            {...calAttrs}
            className="inline-flex min-h-[44px] items-center rounded-full bg-honey px-6 font-mono text-xs uppercase tracking-[0.08em] text-ink transition-colors duration-300 ease-quint hover:bg-honey-soft"
          >
            {t.book}
          </a>
        </div>

        {/* Wordmark uriaș */}
        <div className="flex items-end justify-center pt-12">
          <DrawnApostrophe className="!h-[16vw] !w-[6vw]" />
          <h2 className="display-italic select-none text-center text-[22vw] leading-[0.8] md:text-[20vw]">vorba</h2>
          <span className="mb-[3vw] ml-2 font-mono text-[2vw] text-cream-muted">.dev</span>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-between gap-x-6 gap-y-2 text-cream-muted">
          <span className="eyebrow-light text-cream-muted">© {new Date().getFullYear()} — vorba.dev · {t.kept}</span>
          <nav className="flex flex-wrap gap-x-5 gap-y-1">
            <L to="/privacy" className="eyebrow-light inline-flex min-h-[44px] items-center">{t.privacy}</L>
            <L to="/terms" className="eyebrow-light inline-flex min-h-[44px] items-center">{t.terms}</L>
            <L to="/imprint" className="eyebrow-light inline-flex min-h-[44px] items-center">{t.imprint}</L>
          </nav>
          <span className="eyebrow-light text-cream-muted">{t.cities}</span>
        </div>
      </div>
    </footer>
  )
}
